import React, { useEffect, useState } from "react";
import { Checkbox } from "antd";
import FormItem from "../FormItem";
import images from "../../../assets/images";

const CheckboxGroup = ({
  handleTextFieldChange,
  checkboxes,
  handleCheckboxChange,
  checkedFields,
  groupName = "",
  choice_has_val,
  textFieldValues,
  form,
  other_placeholder,
  choice_value_placeholder,
}) => {
  const [optionsValue, setOptionsValue] = useState({
    checkboxId: "",
    option: null,
    value: "",
  });

  useEffect(() => {
    handleTextFieldChange(optionsValue);
  }, [optionsValue]);

  useEffect(() => {
    // filling in default values to free-entry field
    checkboxes.forEach((checkbox) => {
      setOptionsValue((prev) => ({
        ...prev,
        checkboxId: checkbox.id,
        option: textFieldValues[checkbox.id]?.option || null,
        value: textFieldValues[checkbox.id]?.value,
      }));
    });
  }, []);

  const options = checkboxes.map((checkbox) => {
    return {
      label: (
        <div key={checkbox.id}>
          {checkbox.option}
          {choice_has_val && checkedFields?.includes(checkbox.id) && (
            <>
              <img src={images.Connector} className="connector" />
              <div
                className={`flex ${
                  checkbox.option_has_text ? "other-field" : ""
                }`}
              >
                {checkbox.option_has_text && (
                  <FormItem
                    id={checkbox.id + "text"}
                    name={checkbox.id + "text"}
                    qnId={checkbox.id + "text"}
                    className="checkbox-textfield preassessment-field option"
                    placeholderText={other_placeholder}
                    onChange={(e) => {
                      e &&
                        setOptionsValue((prev) => ({
                          value: prev?.value,
                          checkboxId: checkbox.id,
                          option: e.text_answer,
                        }));
                    }}
                    answer={{
                      text_answer: textFieldValues[checkbox.id]?.option,
                    }}
                    rules={[
                      {
                        required: true,
                        message: other_placeholder + " is required",
                      },
                    ]}
                    isLabelEnabled={false}
                    form={form}
                  />
                )}
                <FormItem
                  name={checkbox.id + "total"}
                  className="checkbox-textfield preassessment-field"
                  placeholderText={choice_value_placeholder}
                  inputType="integer"
                  onChange={(e) => {
                    e &&
                      setOptionsValue((prev) => ({
                        checkboxId: checkbox.id,
                        value: e,
                        option: checkbox.option_has_text ? prev?.option : null,
                      }));
                  }}
                  answer={{
                    text_answer: textFieldValues[checkbox.id]?.value,
                  }}
                  rules={[
                    {
                      required: true,
                      message: choice_value_placeholder + " is required",
                    },
                  ]}
                  isLabelEnabled={false}
                  form={form}
                  required
                  autoFocus
                />
              </div>
            </>
          )}
        </div>
      ),
      value: checkbox.id,
    };
  });

  const handleCheckboxCheck = (checkedValues) => {
    const newlyCheckedValue = checkedValues.find(
      (value) => !checkedFields.includes(value)
    );
    setTimeout(() => {
      const isOtherSelected = document.getElementById(
        newlyCheckedValue + "text"
      );
      // scroll to textfield
      if (isOtherSelected) {
        isOtherSelected.scrollIntoView({
          behavior: "smooth",
        });
      }
    }, 10);
    handleCheckboxChange(checkedValues);
  };

  return (
    <div>
      <h3 className="group-name">{groupName}</h3>
      <Checkbox.Group
        onChange={handleCheckboxCheck}
        value={checkedFields}
        options={options}
      />
    </div>
  );
};

export default CheckboxGroup;
